import React from 'react';
import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import classnames from 'classnames';

const DropZone = (props) => {
  const {
    dropHalf,
    searchPin,
  } = props; // parent props

  const {
    draggedItem,
    isHovered,
    connectDropTarget,
  } = props; // React DnD props

  const isDragged = (draggedItem && draggedItem.key) === searchPin.key;

  return connectDropTarget(
    <span
      key="0"
      className={classnames(
        `drop-zone-${dropHalf}`,
        { "is-hovered": isHovered && !isDragged },
      )}
    />
  );
};

DropZone.propTypes = {
  dropHalf: PropTypes.string.isRequired,
  searchPin: PropTypes.shape({}).isRequired,

  // props used for React DnD wrapper
  /* eslint-disable react/no-unused-prop-types */
  dispatch: PropTypes.func.isRequired,
  /* eslint-enable react/no-unused-prop-types */
};

const dropTarget = {
  drop(props, monitor) {
    const { draggedIndex } = monitor.getItem();
    const hoveredRow = {
      key: props.searchPin.key,
      hoveredHalf: props.dropHalf
    };

    props.dispatch({
      data: { hoveredRow },
      index: draggedIndex,
      type: 'update-row-position',
    });
  }
};

const dropCollect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  draggedItem: monitor.getItem(),
  isHovered: monitor.isOver(),
});

export default DropTarget('search-pin-row', dropTarget, dropCollect)(DropZone);
